module.exports = __webpack_public_path__ + "static/media/reutersWhite.48adcf08.svg";